import React from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import LandingPageBody from './LandingPageBody/LandingPageBody';
import LandingPageFooter from './LandingPageFooter/LandingPageFooter';

import './LandingPage.scss';

function LandingPage() {
  return (
    <div className="landing-page d-flex flex-column align-items-center justify-content-between w-100 py-4">
      <div className="landing-page-header text-center w-100 mb-3">
        <CharmaLogo className="landing-page-logo w-100" />
      </div>
      <div className="mb-3">
        <LandingPageBody />
      </div>
      <LandingPageFooter />
    </div>
  );
}

export default LandingPage;
